import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden py-28" data-id="element-133">
      {/* Background Image & Overlay */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1589829085413-56de8ae18c73?auto=format&fit=crop&q=80")',
      backgroundPosition: 'center 30%'
    }} data-id="element-134" />
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-[#1a1a1a]/80 via-[#1a1a1a]/70 to-[#1a1a1a]/90" data-id="element-135" />

      {/* Content */}
      <div className="relative z-20 max-w-5xl mx-auto px-5 sm:px-6 text-center mt-16 sm:mt-20" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-center" data-id="element-137">
          <span className="text-white/90 text-xs sm:text-sm md:text-base font-semibold tracking-[0.15em] sm:tracking-[0.2em] uppercase mb-5 sm:mb-6 block" data-id="element-138">
            Serious Attorneys in Pursuit of Serious Results in Orange County
          </span>

          <h1 className="font-serif text-3xl sm:text-5xl md:text-6xl lg:text-7xl text-white font-bold leading-tight mb-4 drop-shadow-lg" data-id="element-139">
            30+ Years of Client-Focused
            <br className="hidden sm:block" data-id="element-140" /> Representation
          </h1>

          <h2 className="font-serif text-xl sm:text-2xl md:text-4xl text-white/90 italic mb-6 sm:mb-8" data-id="element-141">
            & The Results To Back It Up
          </h2>

          <p className="text-gray-300 text-xs sm:text-sm md:text-lg max-w-2xl mx-auto mb-8 sm:mb-10 tracking-wide uppercase" data-id="element-142">
            Full-Service Law Firm Helping Clients in 6 Different Areas of the
            Law
          </p>

          <motion.a href="#contact" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="bg-[#c9a35a] hover:bg-[#bfa15a] text-[#1a1a1a] font-serif font-bold text-base sm:text-lg md:text-xl px-8 sm:px-10 py-3.5 sm:py-4 transition-colors shadow-xl" data-id="element-143">
            Contact Us
          </motion.a>
        </motion.div>
      </div>
    </section>;
}